import { render, staticRenderFns } from "./ProfileDropZone.vue?vue&type=template&id=2b11ccc2&scoped=true&"
import script from "./ProfileDropZone.vue?vue&type=script&lang=js&"
export * from "./ProfileDropZone.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDropZone.vue?vue&type=style&index=0&id=2b11ccc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b11ccc2",
  null
  
)

export default component.exports